import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { blogSearchModel, getPagesByParent, searchBlogparameter } from "@tCentro/Services/CENBlogSearchService";

 
 type HandlerType = ApiHandler<
 searchBlogparameter & HasOnSuccess<blogSearchModel>,
 blogSearchModel
 >;
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const DispatchBeginCreditMemo: HandlerType = props => {
    (props as any).dispatch({
        type: "Custom/CreditMemoData/BeginLoad",
    });
};
 
export const SendDataToApi: HandlerType = async props => {
    try {   
            props.apiResult = await getPagesByParent(props.apiParameter.searchQuery); 
        }
       
        
    catch (error) { 
        logger.error("Error fetching Price Book data:", error);
        props.parameter.onError?.();
    }
};




export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    
    props.parameter.onSuccess?.(props.apiResult.titles===null? []:props.apiResult.titles);
};
export const DispatchCompleteCreditMemo: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    (props as any).dispatch({
        type: "Custom/CreditMemo/CompletedLoad",
        result: props.apiResult,
    });
};
 
export const chain = [
    DispatchBeginCreditMemo,
    PopulateApiParameter,
    SendDataToApi,
   
    ExecuteOnSuccessCallback,
    DispatchCompleteCreditMemo,
  
];
 
const searchBlogHandler = createHandlerChainRunner(chain, "searchBlogHandler");
export default searchBlogHandler;